<template>
  <div
    id="snackbar-simple-banner"
    :class="['ob1-snackbar', { 'show': messages.length !== 0 }]"
    role="status"
    aria-live="polite"
    aria-atomic="true"
    data-ob1-component="Snackbar">
    <div
      v-if="lastMessage"
      class="ob1-snackbar-wrapper">
      <span
        :class="['ob1-snackbar-icon', icon]"
        aria-hidden="true" />
      <p class="ob1-snackbar-label">
        {{ lastMessage.text }}
      </p>
    </div>
  </div>
</template>

<script>
import WptvSnackbarConfig from './snackbar.config'
import _get from 'lodash/get'

export default {
  name: 'WptvSnackbar',
  props: {
    name: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      messages: []
    }
  },
  computed: {
    lastMessage () {
      return this.messages[this.messages.length - 1]
    },
    icon () {
      return WptvSnackbarConfig.icons[_get(this.lastMessage, 'type', 'INFO')]
    }
  },
  mounted () {
    this.$root.$on('snackbar', this.show)
  },
  methods: {
    /**
     * Add message to the stack
     * @param text - the message to show
     * @param type - to define the type (error, warning, info, success)
     * @param position - used to position the snackbar in absolute coordinates
     * @param delay - used to overload default delay
     * @param name
     */
    show ({ text, type, delay, name }) {
      if (!name || name === this.name) {
        const message = { text, type }
        this.messages.push(message)

        setTimeout(() => {
          this.messages.splice(this.messages.indexOf(message), 1)
        }, delay || WptvSnackbarConfig.delay)
      }
    }
  }
}
</script>
